import { z } from "zod";

export const TransactionLineDtoSchema = z.object({
  productCode: z.string(),
  quantity: z.number(),
  value: z.number(),
  unitPrice: z.number(),
});

/**
 * The ZOD Schema for the resonse records from the /declined-transactions/search endpoint
 */
export const SearchDeclinedTransactionDtoSchema = z.object({
  id: z.string(),
  locationCode: z.string(),
  locationName: z.string().nullable(),
  currencyCode: z.string(),
  transactionDateTime: z.coerce.date(),
  voucherTransactionNo: z.string(),
  cardNumber: z.string(),
  authorisationNumber: z.string(),
  totalTransactionValue: z.number(),
  declineCode: z.string(),
  parentTerminalId: z.string(),
  childTerminalId: z.string(),
  odometer: z.number().nullable(),
  captureType: z.string(),
  transactionLines: z.array(TransactionLineDtoSchema).nullable(),
});

/**
 * The ZOD Schema for the expected response body from the `/declined-transactions/search` endpoint
 */
export const SearchDeclinedTransactionsResponseSchema = z.object({
  count: z.number(),
  totalResults: z.number(),
  offset: z.number(),
  limit: z.number(),
  results: SearchDeclinedTransactionDtoSchema.array(),
});

export type TransactionLineDto = z.infer<typeof TransactionLineDtoSchema>;

/**
 * Defines the records returned by the `/declined-transactions/search` endpoint
 *
 * These are declined transactions provided by worldline
 */
export type SearchDeclinedTransactionDto = z.infer<
  typeof SearchDeclinedTransactionDtoSchema
>;

/**
 * Defines the response body expected from the `/declined-transactions/search` endpoint
 */
export type SearchDeclinedTransactionsResponse = z.infer<
  typeof SearchDeclinedTransactionsResponseSchema
>;

export const DeclineCodeDtoSchema = z.object({
  id: z.string(),
  declineCode: z.string(),
  declineDescripton: z.string(),
});

export const ListDeclineCodeResponseSchema = z.object({
  count: z.number(),
  results: DeclineCodeDtoSchema.array(),
});

export type DeclineCodeDto = z.infer<typeof DeclineCodeDtoSchema>;
export type ListDeclineCodeResponse = z.infer<
  typeof ListDeclineCodeResponseSchema
>;

/**
 * Defines the scema for the body from the `/declined-transactions/{id}' endpoint
 */
export const GetDeclinedTransactionResponseSchema = z.object({
  id: z.string(),
  locationCode: z.string(),
  locationName: z.string().nullable(),
  currencyCode: z.string(),
  transactionDateTime: z.coerce.date(),
  voucherTransactionNo: z.string(),
  cardNumber: z.string(),
  authorisationNumber: z.string(),
  totalTransactionValue: z.number(),
  declineCode: z.string(),
  parentTerminalId: z.string(),
  childTerminalId: z.string(),
  odometer: z.number().nullable(),
  captureType: z.string(),
  transactionLines: z.array(TransactionLineDtoSchema).nullable(),
});

export type GetDeclinedTransactionResponse = z.infer<
  typeof GetDeclinedTransactionResponseSchema
>;

export const LatestFileUploadResponseSchema = z.object({
  id: z.string(),
  fileCreationDateTime: z.string().datetime({
    offset: true,
  }),
  fileExtractedDateTime: z.string().datetime({
    offset: true,
  }),
  fileRecievedDateTime: z.string().datetime({
    offset: true,
  }),
  fileName: z.string(),
  fileUri: z.string(),
  fileSize: z.number(),
  fileRecordCount: z.number(),
  importedRecordCount: z.number(),
});

/**
 * Defines the records returned by the `/file-uploads/latest` endpoint
 *
 * These in metadata for the last file recieved
 */
export type LatestFileUploadResponse = z.infer<
  typeof LatestFileUploadResponseSchema
>;
